import axios from 'axios'

export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  informacastlogList (context, opts) {
    if (!context.state.fetchingList) {
      context.commit('INFORMACASTLOG_FETCHING_LIST', true)
      return new Promise((resolve, reject) => {
        axios
          .get('/api/informacastlog', { params: opts })
          .then(({ data }) => {
            context.commit('INFORMACASTLOG_LIST', data)
            resolve(data)
          })
          .catch((error) => reject(error))
          .finally(() => context.commit('INFORMACASTLOG_FETCHING_LIST', false))
      })
    }
  },
  // ==========================Socket Updates==============================
  informacastlogUpdated (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inList = context.state.list.find((i) => i.id === id)
    if (inList) {
      axios
        .get(`/api/informacastlog/${id}`)
        .then(({ data }) => {
          context.commit('INFORMACASTLOG_LIST_UPDATE', data)
        }).catch(() => {
        })
    }
  },
  informacastlogDestroyed (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    if (id === context.state.current.id) {
      context.commit('INFORMACASTLOG_CURRENT', null)
    }
    context.commit('INFORMACASTLOG_LIST_ITEM_REMOVE', opts)
  },
  // ======================================================================
  // ==========================Item Management=============================
  // ======================================================================
  informacastlogDetail (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inputs = { }
    if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
      inputs.params = { }
      inputs.params.populate = opts.populate
    }
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/informacastlog/${id}`, inputs)
        .then(({ data }) => {
          context.commit('INFORMACASTLOG_CURRENT', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  informacastlogUpdate (context, opts) {
    const options = { id: opts.id, masterTemplate: opts.masterTemplate }
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/informacastlog/${options.id}`, options)
        .then(({ data }) => {
          if (opts.updateList) {
            context.commit('INFORMACASTLOG_LIST_RESET_MASTER_TEMPLATE')
          } else {
            context.commit('INFORMACASTLOG_CURRENT', data)
          }
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  }
}
